<script lang="ts">
  // properties forwarding
  export let value: number
</script>

<input
  type="number"
  bind:value
  {...$$restProps}
  class="text-input w-full lg:w-1/3 p-2 outline-none focus:ring-2 focus:ring-opacity-50 focus:ring-offset-2 focus:ring-offset-black focus:ring-white text-black [&[readonly]::-webkit-outer-spin-button]:appearance-none [&[readonly]::-webkit-inner-spin-button]:appearance-none read-only:[appearance:textfield] read-only:[-moz-appearance:textfield]"
  on:change
  on:click
  on:keydown
  on:keypress
  on:keyup
/>
